import { computed } from 'vue'
import { useAuthStore } from '@/stores/auth'
import type { TaskBoardsState } from './state'

export const createGetters = (state: TaskBoardsState) => {
  const sortedBoards = computed(() =>
    [...state.boards].sort((a, b) => a.createdAt.getTime() - b.createdAt.getTime())
  )

  const myBoards = computed(() => {
    const authStore = useAuthStore()
    const userId = authStore.user?.id
    if (!userId) return []
    return sortedBoards.value.filter((b) => b.createdBy === userId)
  })

  const sharedBoards = computed(() => {
    const authStore = useAuthStore()
    const userId = authStore.user?.id
    if (!userId) return []
    return sortedBoards.value.filter((b) =>
      b.createdBy !== userId && b.members.includes(userId)
    )
  })

  const boardById = (boardId: string) => {
    return state.boards.find((b) => b.id === boardId) || null
  }

  return {
    sortedBoards,
    myBoards,
    sharedBoards,
    boardById,
  }
}
